<!-- 积分结算详情 -->

<template>
  <div class="scenic-settlement-details">
    <w-dialog ref="dialogRef" title="详情" width="70%" btnWidth="140px" top="10vh" :hideFooter="true">
      <!-- 消费抵扣 -->
      <table class="details-table" style="clear: both" v-if="infoDatas.mi_source == '3'">
        <tbody>
          <tr>
            <th>订单编号</th>
            <td colspan="3">
              {{ infoDatas.or_sn ? infoDatas.or_sn : infoDatas.other_sn }}
              <el-button v-if="infoDatas.or_sn" type="primary" @click="onOrderInfo" class="order-info">查看详情</el-button>
            </td>

            <th>资源名称</th>
            <td>{{ infoDatas.source_name }}</td>
          </tr>
          <tr>
            <th>会员ID</th>
            <td>{{ infoDatas.m_id }}</td>

            <th>会员手机</th>
            <td>{{ infoDatas.m_mobile }}</td>

            <th>操作人</th>
            <td>{{ infoDatas.mi_adder }}</td>
          </tr>
          <tr>
            <th>抵扣时间</th>
            <td>{{ infoDatas.created_at }}</td>

            <th>抵扣积分</th>
            <td colspan="3">{{ infoDatas.mi_integration }}</td>
          </tr>
        </tbody>
      </table>
      <table class="details-table" style="clear: both" v-else>
        <tbody>
          <tr>
            <th>赠送类型</th>
            <td>{{ infoDatas.mi_source_label }}</td>

            <th>资源名称</th>
            <td>{{ infoDatas.source_name }}</td>

            <th>赠送时间</th>
            <td>{{ infoDatas.created_at }}</td>
          </tr>
          <tr>
            <th>操作人</th>
            <td>{{ infoDatas.mi_adder }}</td>

            <th>会员ID</th>
            <td>{{ infoDatas.m_id }}</td>

            <th>会员手机</th>
            <td>{{ infoDatas.m_mobile }}</td>
          </tr>
          <!-- 积分来源。1:认证房产；2：手工补录；3：消费抵扣；4：消费赠送积分；5：充值; 6：退款; -->
          <!-- 消费赠送 -->
          <tr v-if="infoDatas.mi_source == '4'">
            <th>赠送积分</th>
            <td>{{ infoDatas.mi_integration }}</td>

            <th>关联订单</th>
            <td colspan="3">
              {{ infoDatas.or_sn }}
              <el-button v-if="infoDatas.or_sn" type="primary" @click="onOrderInfo" class="order-info">查看详情</el-button>
            </td>
          </tr>
          <!-- 购房赠送、手动补录 -->
          <tr v-else>
            <th>赠送积分</th>
            <td colspan="5">{{ infoDatas.mi_integration }}</td>
          </tr>
        </tbody>
      </table>

      <div class="l-m-t">
        <w-title :title_name="'备注'"></w-title>
        <div class="notes">{{ infoDatas.mi_remark }}</div>
      </div>
    </w-dialog>

    <!-- 订单详情 -->
    <SettlementOrderInfo ref="orderDetailRef"></SettlementOrderInfo>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch, } from "vue";
import { ElMessage, } from "element-plus";
import { ScenicApi, } from "@/plugins/api.js";
import { useStore } from "vuex";
import SettlementOrderInfo from "./SettlementOrderInfo.vue";
import {
  getPayStatusColors,
  getWorkStatusColors,
  getPayStatusOptions,
  getHotelWorkStatusOptions,
} from "@/utils/common.js";

export default {
  emits: ["refreshLists", "closeLoading",],
  components: { SettlementOrderInfo, },
  setup(props, { emit }) {
    // 权限
    const store = useStore();
    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    const dialogRef = ref(null);  // 对话框
    const currentId = ref('');  // 当前id
    const infoDatas = ref('');  // 详情数据
    const orderDetailRef = ref(null);  // 订单详情
    const payStatusOptions = ref(getPayStatusOptions());
    const payStatusColors = ref(getPayStatusColors());
    const workStatusOptions = ref(getHotelWorkStatusOptions());
    const workStatusColors = ref(getWorkStatusColors());
    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (id) => {
      currentId.value = id;
      getDetails();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getDetails = () => {
      ScenicApi.getIntegralSettlementInfo({ mi_id: currentId.value, }).then((res) => {
        if (res.Code === 200) {
          emit('closeLoading');
          infoDatas.value = res.Data;
          dialogRef.value.show();
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 订单详情
     * 
     * **/
    const onOrderInfo = () => {
      let sn = infoDatas.value.or_sn ? infoDatas.value.or_sn : infoDatas.value.other_sn;
      orderDetailRef.value.openDialog(sn, {
        payStatus: {
          options: payStatusOptions.value,
          colors: payStatusColors.value,
        },
        workStatus: {
          options: workStatusOptions.value,
          colors: workStatusColors.value,
        },
      });
    }

    onMounted(() => { });

    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      getDetails,
      infoDatas,
      authData,
      currentId,
      orderDetailRef,
      onOrderInfo,
    };
  },
};
</script>

<style lang="scss">
.scenic-settlement-details {
  .el-dialog__body {
    height: 700px;
    overflow: auto;
  }

  .details-table th {
    background-color: #F3F4F8;
    color: #92979E;
    width: 120px;
    padding: 0 15px;
    border: 1px solid #e6e8ec !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
  }

  .details-table {
    width: 100%;
    background-color: #fff;
    border: 1px solid #e6e8ec !important;
    text-align: left;
    font-size: 14px;
  }

  .details-table td {
    padding: 0 15px;
    height: 42px;
    line-height: 42px;
    border: 1px solid #e6e8ec !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #262C30;
    max-width: 300px;
  }

  .notes {
    background-color: var(--search-uncheck-bg-color);
    height: 180px;
    border-radius: 5px;
    padding: 15px;
    overflow-y: auto;
  }

  .order-info {
    padding: 0;
    width: 80px;
    min-height: 30px;
    margin-left: 10px;
  }
}
</style>